import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "Component", "formControlUse", "dataTestId", "label"],
  _excluded2 = ["hoverContent", "hideDisplayOptimizedBorderIndicator", "verticalSeparation", "onDetailsClick"];
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import { useProperty } from '../hooks/useProperty';
import { useGetIsUngated } from '../hooks/useGetIsUngated';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import DefaultHoverContent from '../../input/hoverContent/DefaultHoverContent';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const getLabel = property => {
  return property.hubspotDefined ? propertyLabelTranslator(property.label) : property.label;
};
const PropertyInputFormControl = _ref => {
  let {
      children,
      Component = FormControl,
      formControlUse = 'default',
      dataTestId: dataTestIdProp,
      label
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const property = useProperty();
  const getIsUngated = useGetIsUngated();
  if (formControlUse === 'inline' || formControlUse === 'table-cell' || !Component) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  const hasLabelGate = getIsUngated('CRM:Properties:DefaultLabel');
  const defaultLabel = hasLabelGate ? getLabel(property) : undefined;
  const resolvedLabel = label === undefined ? defaultLabel : label;
  const isDisplayOptimized = formControlUse === 'floating' || rest.displayOptimized;
  const resolvedDataTestId = (dataTestIdProp !== null && dataTestIdProp !== void 0 ? dataTestIdProp : isDisplayOptimized) ? 'DisplayOptimizedFormControl' : 'FormControl';
  if (isDisplayOptimized) {
    const {
        hoverContent,
        hideDisplayOptimizedBorderIndicator,
        verticalSeparation,
        onDetailsClick
      } = rest,
      other = _objectWithoutPropertiesLoose(rest, _excluded2);
    const resolvedHoverContent = hoverContent === undefined ? /*#__PURE__*/_jsx(DefaultHoverContent, {
      onDetailsClick: onDetailsClick
    }) : hoverContent;
    return /*#__PURE__*/_jsx(FormControl, Object.assign({
      displayOptimized: true,
      hideDisplayOptimizedBorderIndicator: hideDisplayOptimizedBorderIndicator,
      label: resolvedLabel,
      verticalSeparation: verticalSeparation,
      hoverContent: resolvedHoverContent,
      "data-test-id": resolvedDataTestId
    }, other, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(Component, Object.assign({
    "data-test-id": resolvedDataTestId,
    label: resolvedLabel
  }, rest, {
    children: children
  }));
};
export default PropertyInputFormControl;